module.exports = __webpack_public_path__ + "assets/img/jam_alert-f.718cf803.svg";